export enum TYPE_COURRIER {
    TCOUR_REF_CODE = 'TCOUR_REF',
    TCOUR_IRR_CODE = 'TCOUR_IRR',
    TCOUR_ATT_CODE = 'TCOUR_ATT',
    TCOUR_ACC_CODE = 'TCOUR_ACC',
    TCOUR_RPT_CODE = 'TCOUR_RPT',
    TCOUR_TSF_CODE = 'TCOUR_TSF',
    TCOUR_TEL_CODE = 'TCOUR_TEL'
}
